import TextField from '@mui/material/TextField';

const FromTextField =  ({
  label = "ＳＴＰ生産工場",
  helperText = "",
  onChange = (event: any) => { onChange(event); }
}) => (
  <TextField id="tfSTPSeisanKojo"
    label={label}
    size="small"
    inputProps={{ maxLength: 8 }}
    onChange={(event: any) => { onChange(event); }}
    error={!!helperText}
    helperText={helperText}
  />
);

export default FromTextField;